import { useState } from 'react';
import styled from 'styled-components';

import {
  SortIcon,
  FilterIcon,
} from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';
import { theme } from '@frontend/legacy-components/src/theme/theme';

import { useTableContext } from '../utils/TableContext';
import updateConfigs from '../utils/updateConfigs';
import FilterPopover from './FilterPopover';

const SortPriorityLabel = styled.span`
  font-size: ${(props) => props.theme.fontSizes.sm};
  line-height: ${(props) => props.theme.lineHeights.sm};
  color: ${(props) => props.theme.colors.interaction.main};
  display: inline-flex;
  margin-left: 0.25rem;
  min-width: fit-content;

  ${(props) =>
    props.$hidden &&
    `
    display: none;
  `}
`;
SortPriorityLabel.defaultProps = { theme };

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: fit-content;
  height: 2rem;
  width: 100%;
  padding: 0rem;

  .button {
    cursor: pointer;
    min-width: max-content;

    :hover {
      background-color: ${(props) => props.theme.colors.page.plateLight};
      filter: brightness(97%);
    }

    :focus {
      box-shadow: inset 0 0 0 3px
        ${(props) => props.theme.colors.interaction.focus};
    }
    outline: none;
    height: 100%;
  }

  .button-container {
    display: inline;
    font-weight: ${(props) => props.theme.fontWeights.heavy};
    font-size: ${(props) => props.theme.fontSizes.md};
    font-family: ${(props) => props.theme.fonts.default};
    text-transform: capitalize;
    padding: 0 0.75rem;
    text-align: inherit;
    vertical-align: middle;
    flex-grow: 1;
  }

  .non-button-container {
    display: inline;
    font-weight: ${(props) => props.theme.fontWeights.heavy};
    font-size: ${(props) => props.theme.fontSizes.md};
    font-family: ${(props) => props.theme.fonts.default};
    text-transform: capitalize;
    padding: 0 0.75rem;
    flex-grow: 1;
  }
`;
Wrapper.defaultProps = { theme };

/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/legacy-components' instead.
 */
const HeaderCellContent = ({
  align,
  title,
  hasSorting,
  dataIndex,
  filterInputComponent,
  empty,
  formatter,
}) => {
  const { filterConfigs, setFilterConfigs } = useTableContext();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Wrapper $align={align} className="header-cell-content">
      {hasSorting == true ? (
        <button
          onClick={() => {
            // Get the current filterConfig for this dataIndex;
            const { sortDirections, sortState, ...rest } =
              filterConfigs[dataIndex];
            // Get the next sort state based on the available sort directions;
            const nextSortDirection = [null, ...sortDirections][
              [null, ...sortDirections].indexOf(sortState.direction) + 1 >
              [null, ...sortDirections].length - 1
                ? 0
                : [null, ...sortDirections].indexOf(sortState.direction) + 1
            ];

            const newConfig = {
              sortDirections,
              sortState: {
                direction: nextSortDirection,
                priority: sortState.priority,
              },
              ...rest,
            };

            setFilterConfigs(
              updateConfigs(filterConfigs, dataIndex, newConfig),
            );
          }}
          className="button button-container"
        >
          {title}
          <SortIcon
            size={2.5}
            marginInlineEnd="-0.25rem"
            marginBlock="-0.25rem"
            color="feature.placeholder"
          />

          {filterConfigs != undefined
            ? filterConfigs[dataIndex].sortState.priority > 0 && (
                <SortPriorityLabel>
                  {filterConfigs[dataIndex].sortState.priority}
                </SortPriorityLabel>
              )
            : null}
        </button>
      ) : (
        <span className="non-button-container">{title}</span>
      )}
      {filterInputComponent != null && (
        <FilterPopover
          title={title}
          dataIndex={dataIndex}
          filterInputComponent={filterInputComponent}
          formatter={formatter}
          empty={empty}
          isOpen={isPopoverOpen}
          onClose={() => setIsPopoverOpen(false)}
          onApply={() => setIsPopoverOpen(false)}
          onClear={() => setIsPopoverOpen(false)}
        >
          <button
            className="button"
            onClick={() => setIsPopoverOpen(!isPopoverOpen)}
          >
            <FilterIcon color="feature.placeholder" mx="0.25rem" />
          </button>
        </FilterPopover>
      )}
    </Wrapper>
  );
};

export default HeaderCellContent;
